<template>
  <div>
    <!-- 客户分配 -->
    <baseBreadcrumb :page="$t('message.distributionAllocation')" :menu="$t('message.customerManagement')">
    </baseBreadcrumb>
    <!-- 主体 -->
    <div class="body">
      <!-- 搜索 -->
      <div class="search">
        <div class="row">
          <!-- 人员范围 -->
          <!-- <div class="item">
            <cascader @setUserList="setUserList" :org_id="datas.org_id" ref="cascader" />
          </div> -->
          <!-- 筛选同层级人员 -->
          <!-- <el-button type="primary" @click="search">
            {{ $t("message.screenPeers") }}
          </el-button> -->
          <!-- 操作 -->
        </div>
        <div class="operation">
          <!-- 比例设置 -->
          <el-button type="primary" class="dark" @click="proportionSet">
            {{ $t("message.proportionSet") }}
          </el-button>
        </div>
      </div>
      <div class="table">
        <el-table :data="tableData" :default-sort="{ prop: 'date', order: 'descending' }"
          :header-cell-style="{ background: '#EDEFF4' }" style="width: 100%">
          <el-table-column type="index" align="center" label="NO">
          </el-table-column>
          <!--  部门-->
          <el-table-column align="center" :label="$t('message.department')">
            <template slot-scope="scope">
              {{ scope.row.roles[0].org_name }}
            </template>
          </el-table-column>
          <!--  客户总数-->
          <el-table-column align="center" :label="$t('message.theTotalNumberOfCustomers')" prop="client_count">
          </el-table-column>
          <!--  账号-->
          <el-table-column align="center" :label="$t('message.accountNumber')" prop="username">
          </el-table-column>
          <!--  角色-->
          <el-table-column align="center" :label="$t('message.role')">
            <template slot-scope="scope">
              {{ scope.row.roles[0].name }}
            </template>
          </el-table-column>
          <!--  部门成员-->
          <el-table-column align="center" :label="$t('message.departmentNumber')" prop="realname">
          </el-table-column>
          <!--  客户分配比例-->
          <el-table-column align="center" :label="$t('message.customerAllocationRatio')"
            prop="allot_setting.same_level_rate">
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="paginationContainer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
          :page-sizes="[10, 20, 50, 100]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
      <!-- 比例设置 -->
      <el-dialog :title="$t('message.proportionSet')" :close-on-click-modal="false" :visible.sync="dialogVisible"
        width="800px" center>
        <el-table :data="tableData" :default-sort="{ prop: 'date', order: 'descending' }"
          :header-cell-style="{ background: '#EDEFF4' }" style="width: 100%" max-height="400px">
          <!--  部门-->
          <el-table-column align="center" :label="$t('message.department')">
            <template slot-scope="scope">
              {{ scope.row.roles[0].org_name }}
            </template>
          </el-table-column>
          <!--  部门成员-->
          <el-table-column align="center" :label="$t('message.departmentNumber')" prop="realname">
          </el-table-column>
          <!--  比例设置-->
          <el-table-column align="center" :label="$t('message.proportionSet')">
            <template slot-scope="scope">
              <el-input v-model="scope.row.allot_setting.same_level_rate" type="number"></el-input>
            </template>
          </el-table-column>
          <!--  有下层级时 分配到自身的比例-->
          <!-- <el-table-column align="center" :label="$t(
            'message.theProportionAllocatedToItselfWhenThereAreLowerLevels'
          )
            ">
            <template slot-scope="scope">
              <el-input v-model="scope.row.allot_setting.next_level_rate" type="number"></el-input>
            </template>
          </el-table-column> -->
        </el-table>
        <span slot="footer" class="dialog-footer">
          <!--取 消  -->
          <el-button @click="dialogVisible = false">{{
            $t("message.cancel")
          }}</el-button>
          <!-- 保存 -->
          <el-button type="primary" @click="setPAllotRate">{{
            $t("message.ok")
          }}</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: false,
      datas: { org_id: "", pageSize: 50 },
      tableData: [],
      setTableData: [],
      total: 0,
    };
  },
  created() {
    this.allotAdminPList();
  },
  methods: {
    allotAdminPList() {
      this.$api.clienteleApi.allotAdminPList(this.datas).then((res) => {
        this.tableData = res.data.data;
        this.total = res.data.total;
      });
    },
    // 人员范围
    setUserList(data) {
      this.datas.org_id = data.id;
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.allotAdminPList();
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.allotAdminPList();
    },
    // 搜索
    search() {
      this.datas.page = 1;
      this.allotAdminPList();
    },
    //显示比例设置
    proportionSet() {
      this.tableData.forEach(item => {
        if (!item.allot_setting.admin_id) {
          item.allot_setting = {
            admin_id: item.id,
            same_level_rate: "",
            next_level_rate: ''
          }
        }
        this.setTableData.push(item)
      })

      this.dialogVisible = true;
    },
    //比例设置
    setPAllotRate() {
      let datas = {
        list: [],
      };
      this.setTableData.forEach((item) => {
        datas.list.push(item.allot_setting);
      });
      this.$api.clienteleApi.setPAllotRate(datas).then((res) => {
        this.$message.success(res.msg);
        this.dialogVisible = false;
        this.allotAdminPList();
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.search {
  margin-bottom: 24px;
  position: relative;

  .row {
    display: flex;
    margin-bottom: 16px;

    .item {
      width: 240px;
      margin-right: 24px;
    }
  }

  // .operation {
  //   position: absolute;
  //   top: 0;
  //   right: 0;
  // }
}
</style>